var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpotCopyTrading = function SvgSpotCopyTrading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.962 5.602 17.82 21.056a1 1 0 0 1-1.224.707L4.038 18.398l4.4-16.42zm-8.41.64a3.3 3.3 0 1 0 .001 6.6 3.3 3.3 0 0 0 0-6.6m-.162 2.02a.176.176 0 0 1 .327 0l.088.213c.15.362.43.652.782.808l.249.11a.185.185 0 0 1 0 .336l-.264.117a1.52 1.52 0 0 0-.771.782l-.085.197a.177.177 0 0 1-.325 0l-.086-.197a1.52 1.52 0 0 0-.77-.782l-.265-.117a.185.185 0 0 1 0-.335l.25-.11c.351-.157.632-.447.782-.81zM4.787 12l2.15-8.02L3.61 5.07a1 1 0 0 0-.64 1.255z"
  })));
};
export default SvgSpotCopyTrading;